import axios from "axios";
import { getConfig } from "../helpers/config";

export class IndirizzoStudioService {
  baseAPIUrl = `${getConfig()?.url}indirizzi`;

  getById = async (id) => {
    return await axios.get(`${this.baseAPIUrl}/${id}`).then((res) => res.data);
  };

  getByIdForDt = async (id) => {
    return await axios
      .get(`${this.baseAPIUrl}/dt/${id}`)
      .then((res) => res.data);
  };

  findByCodice = async (codice) => {
    return await axios
      .get(`${this.baseAPIUrl}/codice/${codice}`)
      .then((res) => res.data);
  };

  downloadTemplate = async () => {
    try {
      const response = await axios.get(`${this.baseAPIUrl}/excel`, {
        responseType: "blob",
      });
      return response;
    } catch (error) {
      console.error("Errore durante il download del template:", error);
    }
  };

  getAllDt = async (data) => {
    return await axios
      .post(`${this.baseAPIUrl}/dt`, data)
      .then((res) => res.data);
  };

  create = async (data) => {
    return await axios
      .post(`${this.baseAPIUrl}/`, data)
      .then((res) => res.data);
  };

  valida = async (file) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await axios.post(`${this.baseAPIUrl}/valida`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      return response.data;
    } catch (error) {
      console.error("Errore durante l'invio del file Excel:", error);
      throw error;
    }
  };

  importa = async (file, bandoId) => {
    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("bandoId", bandoId);

      const response = await axios.post(
        `${this.baseAPIUrl}/importa`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Errore durante l'importazione del file Excel:", error);
      throw error;
    }
  };

  update = async (data) => {
    return await axios.put(`${this.baseAPIUrl}/`, data).then((res) => res.data);
  };

  delete = async (indirizzoId, plessoId, istitutoId) => {
    return await axios
      .delete(
        `${this.baseAPIUrl}/indirizzo/${indirizzoId}/plesso/${plessoId}/istituto/${istitutoId}`
      )
      .then((res) => res.data);
  };
}
